<script>
// import slogan from '../assets/slogan.png';
import brand_img from '../assets/brand-img.png';
// import cf from '../assets/cf.png';
// import logoSrc from '../assets/logo.svg';
//ab1212
export default {
    data(){
        return {
            brand_img,
            video_text: "2020集印花_好評延長篇",
            link: "https://www.youtube.com/embed/XfvC3a3UJRI"
        }
    },
    methods: {

    },
    mounted(){

        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 1000);
        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 1500);
        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 2000);
        console.log("BDIntro!!")

    }
}

</script>

<template>
    <section class="brand-intro" id="brand-intro">

        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="video-box-wrap">
                        <div class="video-box">
                            <!-- <iframe id="video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe> -->
                            <iframe id="main-video" :src="`${link}?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1`" frameborder="0" allowfullscreen></iframe>
                            <!-- <img :src="cf" alt=""> -->
                        </div>
                        <p class="video-text">{{video_text}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="content-wrap">
                        <div class="img-wrap">
                            <img :src="brand_img" alt="">
                        </div>
                        <p class="text">
                            Royal Doulton皇家道爾頓創立於1815年，擁有超過200年歷史，是英國最大的瓷器出口製造商，更深受皇室喜愛，為英國皇室御用精品餐瓷，百年工藝品質承襲至現代，充滿英倫文化的設計感。藉由與米其林主廚、設計師合作，將時尚及實用同時融入餐具中，展現高質感餐桌品味。
                            
                        </p>
                        <h4 class="title">●   200年的歷史尊榮</h4>
                        <p class="text">
                            約翰道爾頓(John Doulton)在1815年創立道爾頓工作坊，其子亨利道爾頓(Henry Doulton)承繼父志，亨利道爾頓於1887年榮獲維多利亞女王授予騎士爵位，成為英國史上第一位受封爵位的陶藝家。
道爾頓(Doulton)在1901年得到皇帝愛德華七世授權為皇家御用餐瓷，授權冠名使用Royal皇家字樣，正式更名為世界聞名的皇家道爾頓(Royal Doulton)。
                            <br>
                            1966年再次獲得英國皇家認證標章。英國維多利亞女王曾盛讚皇家道爾頓的創立者──約翰道爾頓(John Doulton)為｢最美麗瓷器的創作者｣，並頒發技術成就獎及大英帝國的最佳出口品牌商，以精緻的瓷器深受各國皇室喜愛；就連品味極佳的黛安娜王妃，也是這個品牌的忠實愛好者。
                            <br>
                            1981年黛安娜王妃與查爾斯王子大婚時，Royal Doulton還曾推出兩人的婚禮紀念杯盤，慶祝這歷史上最重要的時刻。
                        </p>
                        <h4 class="title">●   在餐桌創造有意義的連結，感受歡笑，享受生活</h4>
                        <p class="text">
                            走過200多年的歷史尊榮，皇家道爾頓除珍視歷史資產，也透過與當代藝術家合作，創造豐富的風格，引導人們體驗截然不同的餐桌體驗，啟發人們Mix & Match居家空間獨特性與多樣性，也鼓勵人們在桌邊創造有意義的聯結與體驗；品牌宣言─「Live Bold」鼓舞人們勇於活出與眾不同的自我，感受歡笑，享受生活。秉持著對傳統工藝及與當代藝術的結合，Royal Doulton與每個世代緊密結合，成功的站到了世界舞台中央。
                        </p>
                        <h4 class="title">●   承襲傳統、充滿手工感的1815恆采系列</h4>
                        <p class="text">為紀念皇家道爾頓200多年的歷史尊榮，創建以明亮色系感染居家活力氛圍的─1815恆采系列，以其特殊製程重現傳統手工感，每一件1815的作品皆為45度角手工浸釉，手工過程使染色深淺、角度與邊緣皆為獨一無二，透過手工刻畫的方式，讓瓷器盤身也有線條感，並帶有RD X 1815手工印記；邊緣的造型也是為沿襲傳統手工感而進行特殊處理，是產品原始設計，也是本系列的特色。</p>
                    </div>

                    <!-- <div class="video-box-wrap">
                        <div class="video-box">
                            <div class="play-btn"></div>
                            <iframe id="brand-video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <p class="video-text">全聯福利中心BOGO FREE DANCE 買一送一</p>
                    </div> -->

                </div>
            </div>
        </div>
    </section>
</template>

<style lang="sass">



@import "../sass/global.sass"
.brand-intro
    overflow: hidden
    position: relative
    background-image: url('../assets/bubble-bg.png')
    background-position-x: center 
    background-size: cover
    padding-top: 80px
    padding-bottom: 80px
    @media (max-width: 991px)
        // margin-bottom: 70px
        padding-top: 80px
        padding-bottom: 80px
    @media (max-width: 768px)
        padding-top: 50px
        padding-bottom: 50px
    @media (max-width: 576px)
        padding-top: 40px
        padding-bottom: 40px




    .content-wrap
        //max-width: 50%
        // background-color: #ab1212
        margin: 0 auto
        text-align: left
        padding-top: 50px
        padding-bottom: 70px
        border-radius: 30px
        padding-left: 30px
        padding-right: 30px
        @media (max-width: 991px)
            //max-width: 80%
            padding-top: 50px
            padding-bottom: 50px
        @media (max-width: 768px)
            max-width: 100%
        @media (max-width: 576px)
            padding: 30px 15px
        .img-wrap
            text-align: center
            margin-bottom: 45px
            @media (max-width: 991px)
                margin-bottom: 40px
            img
                width: 40%
                margin: 0 auto
                max-width: 446px
                min-width: 360px
                @media (max-width: 768px)
                    min-width: 320px
                @media (max-width: 576px)
                    min-width: 240px
                //     max-width: 200px

        .text
            line-height: 30px
            color: #1a1a1a
            letter-spacing: 2px
            font-weight: 300
            font-size: 18px
            text-align: justify
        .title
            color: $green
            font-weight: 400
            letter-spacing: 2px
            margin-top: 40px
    .video-box-wrap
        margin: 0 auto
        max-width: 50%
        margin-bottom: 50px
        @media (max-width: 991px)
            max-width: 70%
        @media (max-width: 768px)
            max-width: 100%
            //padding-bottom: 56.25%
        .video-box
            padding-bottom: 56.25%
            position: relative
            border-bottom: none

            border: 5px solid #000
            iframe, img
                background: black
                position: absolute
                display: block
                top: 50%
                left: 50%
                transform: translate(-50%, -50%)
                width: 100%
                height: 100%

        .video-text
            background: black
            padding: 15px 10px
            text-align: center
            color: white
            font-size: 18px
            letter-spacing: 1px
            @media (max-width: 576px)
                font-size: 14px



</style>



// WEBPACK FOOTER //
// src/Index/BrandIntro.vue